import React from 'react';

import cn from 'classnames';

import s from './AnalysisNumber.module.scss';
import Text from '@components/Text';

interface AnalysisNumberProps {
  number: number;
  className?: string;
}

const AnalysisNumber: React.FC<AnalysisNumberProps> = ({ number, className }) => {
  const getAnalysis = (count: string) => {
    if (count.length > 1) {
      const lastTwoNumbers = +count.slice(count.length - 2, count.length);
      if (lastTwoNumbers >= 11 && lastTwoNumbers <= 19) return count + ' анализов';
    }
    const lastNumber = +count[count.length - 1];
    if (lastNumber === 1) return count + ' анализ';
    if (lastNumber >= 2 && lastNumber <= 4) return count + ' анализа';
    if ((lastNumber >= 5 && lastNumber <= 9) || lastNumber === 0) return count + ' анализов';
  };
  return <Text className={cn(className, s.analysis)}>{getAnalysis(String(number))}</Text>;
};

export default AnalysisNumber;
